import React from 'react';
import PropTypes from 'prop-types';
import Translate from './translate';

require('./message.css');

class Message extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="settings_message" style={{display: this.props.show ? 'block' : 'none'}}>
                <p className={this.props.error ? 'error' : ''}>
                    <Translate locale={this.props.locale}
                               value={this.props.message}/></p>
            </div>
        );
    }
}

Message.propTypes = {
    show: PropTypes.bool,
    message: PropTypes.string,
    error: PropTypes.bool,
};

Message.defaultProps = {
    show: false,
    message: '',
    error: false,
};

export default Message;
